import { useParams } from 'react-router-dom'

import { isLocale } from '@/content/i18n'
import { useUiStore } from '@/store/useUiStore'

export function useLocale() {
  const params = useParams<{ locale?: string }>()
  const localePreference = useUiStore((state) => state.localePreference)

  return isLocale(params.locale) ? params.locale : localePreference
}
